import AbstractService from 'services/AbstractService';
import _ from 'lodash';
import $ from 'jquery';
import TabsService from 'services/TabsService';
import SecurityService from 'services/SecurityService';
import DataExplorerService from 'services/DataExplorerService';
import Constants from 'utils/Constants';
import ProcessValidator from 'utils/ProcessValidator';
import ProcessEditor from 'utils/ProcessEditor';
import ProcessUtils from 'utils/ProcessUtils';

//tell eslint that Promise is a global var
/*global Promise */

/**
 * Provides CRUD services for Processes
 */
class ProcessService extends AbstractService {

    constructor() {
        super();
        this.PROCESSES_FETCH_START = 'PROCESSES_FETCH_START';
        this.PROCESSES_FETCH_SUCCESS = 'PROCESSES_FETCH_SUCCESS';
        this.PROCESSES_FETCH_ERROR = 'PROCESSES_FETCH_ERROR';
        this.PROCESS_FETCH_START = 'PROCESS_FETCH_START';
        this.PROCESS_FETCH_SUCCESS = 'PROCESS_FETCH_SUCCESS';
        this.PROCESS_FETCH_ERROR = 'PROCESS_FETCH_ERROR';
        this.PROCESS_ORIGINAL_FETCH_START = 'PROCESS_ORIGINAL_FETCH_START';
        this.PROCESS_ORIGINAL_FETCH_SUCCESS = 'PROCESS_ORIGINAL_FETCH_SUCCESS';
        this.PROCESS_NEW = 'PROCESS_NEW';
        this.PROCESS_NEW_SUCCESS = 'PROCESS_NEW_SUCCESS';
        this.PROCESS_UNCACHE = 'PROCESS_UNCACHE';
        this.PROCESS_SAVE_START = 'PROCESS_SAVE_START';
        this.PROCESS_SAVE_SUCCESS = 'PROCESS_SAVE_SUCCESS';
        this.PROCESS_SAVE_ERROR = 'PROCESS_SAVE_ERROR';
        this.PROCESS_DELETE_START = 'PROCESS_DELETE_START';
        this.PROCESS_DELETE_SUCCESS = 'PROCESS_DELETE_SUCCESS';
        this.PROCESS_DELETE_ERROR = 'PROCESS_DELETE_ERROR';
        this.PROCESS_RENAME = 'PROCESS_RENAME'; // only use this so the sagas can tell data explorer to sync cache
        this.PROCESS_UPDATE_SUCCESS = 'PROCESS_UPDATE_SUCCESS';
        this.PROCESS_UPDATE_WITH_CALLBACKS = 'PROCESS_UPDATE_WITH_CALLBACKS';
        this.PROCESS_RUN_PARAMETERS_UPDATE = 'PROCESS_RUN_PARAMETERS_UPDATE';
        this.PROCESS_ADD_RETRIEVAL = 'PROCESS_ADD_RETRIEVAL';
        this.PROCESS_REMOVE_RETRIEVAL = 'PROCESS_REMOVE_RETRIEVAL';
        this.PROCESS_OWNERS_FETCH_START = 'PROCESS_OWNERS_FETCH_START';
        this.PROCESS_OWNERS_FETCH_SUCCESS = 'PROCESS_OWNERS_FETCH_SUCCESS';
        this.PROCESS_OWNERS_FETCH_ERROR = 'PROCESS_OWNERS_FETCH_ERROR';
        this.PROCESS_OWNERS_SAVE_START = 'PROCESS_OWNERS_SAVE_START';
        this.PROCESS_OWNERS_SAVE_SUCCESS = 'PROCESS_OWNERS_SAVE_SUCCESS';
        this.PROCESS_OWNERS_SAVE_ERROR = 'PROCESS_OWNERS_SAVE_ERROR';
        this.PROCESS_REVISIONS_FETCH_START = 'REVISIONS_FETCH_START';
        this.PROCESS_REVISIONS_FETCH_SUCCESS = 'REVISIONS_FETCH_SUCCESS';
        this.PROCESS_REVISIONS_FETCH_ERROR = 'REVISIONS_FETCH_ERROR';
        this.PROCESS_REVISION_FETCH_START = 'REVISION_FETCH_START';
        this.PROCESS_REVISION_FETCH_SUCCESS = 'REVISION_FETCH_SUCCESS';
        this.PROCESS_REVISION_FETCH_ERROR = 'REVISION_FETCH_ERROR';
        this.PROCESS_DEPENDENCIES_FETCH_START = 'DEPENDENCIES_FETCH_START';
        this.PROCESS_DEPENDENCIES_FETCH_SUCCESS = 'DEPENDENCIES_FETCH_SUCCESS';
        this.PROCESS_DEPENDENCIES_FETCH_ERROR = 'DEPENDENCIES_FETCH_ERROR';
        this.PROCESS_RUN_START = 'PROCESS_RUN_START';
        this.PROCESS_RUN_SUCCESS = 'PROCESS_RUN_SUCCESS';
        this.PROCESS_RUN_ERROR = 'PROCESS_RUN_ERROR';
        this.PROCESS_IMPORT_SUCCESS = 'PROCESS_IMPORT_SUCCESS';
        this.PROCESS_IMPORT_ERROR = 'PROCESS_IMPORT_ERROR';
        this.PROCESS_VALIDATE = 'PROCESS_VALIDATE';
        this.PROCESS_VALIDATE_SUCCESS = 'PROCESS_VALIDATE_SUCCESS';
        this.PROCESS_VALIDATE_ERROR = 'PROCESS_VALIDATE_ERROR';
        this.PROCESS_SAVE_VALIDATION_START = 'PROCESS_SAVE_VALIDATION_START';
        this.PROCESS_SAVE_VALIDATION_SUCCESS = 'PROCESS_SAVE_VALIDATION_SUCCESS';
        this.PROCESS_GET_RUNS_START = 'PROCESS_GET_RUNS_START';
        this.PROCESS_GET_RUNS_SUCCESS = 'PROCESS_GET_RUNS_SUCCESS';
        this.PROCESS_GET_RUNS_ERROR = 'PROCESS_GET_RUNS_ERROR';
        this.PROCESS_DELETE_RUN_START = 'PROCESS_DELETE_RUN_START';
        this.PROCESS_DELETE_RUN_SUCCESS = 'PROCESS_DELETE_RUN_SUCCESS';
        this.PROCESS_DELETE_RUN_ERROR = 'PROCESS_DELETE_RUN_ERROR';
        this.PROCESS_CANCEL_RUN_START = 'PROCESS_CANCEL_RUN_START';
        this.PROCESS_CANCEL_RUN_SUCCESS = 'PROCESS_CANCEL_RUN_SUCCESS';
        this.PROCESS_CANCEL_RUN_ERROR = 'PROCESS_CANCEL_RUN_ERROR';
        this.PROCESS_IMPORT_RUN_OUPUT_START = 'PROCESS_IMPORT_RUN_OUPUT_START';
        this.PROCESS_IMPORT_RUN_OUPUT_SUCCESS = 'PROCESS_IMPORT_RUN_OUPUT_SUCCESS';
        this.PROCESS_IMPORT_RUN_OUPUT_ERROR = 'PROCESS_IMPORT_RUN_OUPUT_ERROR';
        this.PROCESS_UPDATE_UI_STATE = 'PROCESS_UPDATE_UI_STATE';
        this.PROCESS_CREATE_PROJECT_START = 'PROCESS_CREATE_PROJECT_START';
        this.PROCESS_CREATE_PROJECT_SUCCESS = 'PROCESS_CREATE_PROJECT_SUCCESS';
        this.PROCESS_CREATE_PROJECT_ERROR = 'PROCESS_CREATE_PROJECT_ERROR';
        this.PROCESS_CREATE_PROJECT_UPDATE = 'PROCESS_CREATE_PROJECT_UPDATE';

        this.baseUrl = process.env.REACT_APP_BASE_URL; // process.env comes from webpack build
    }

    getInitialState() {
        return {
            // These are for the catalog of all processes
            processesById: {},
            sortedIds: [],
            processOwnersById: {},

            // These are process-specific sub-state
            processRevisionsById: {},
            revisionHistoriesById: {},
            processUIStateById: {},
            workingCopiesById: {},
            originalCopiesById: {},
            processErrorsById: {},
            processRevisionErrorsById: {},
            runParametersById: {},
            dependencyTreeById: {},
            dataConsolidatorRunsById: {},
            projectParametersById: {}
        };
    }

    /**
     * Use this method to make sure when we always clean up all the correct associated substates associated
     * with a given process.
     * @returns {*[]}
     */
    getSubstateKeys() {
        return [
            'originalCopiesById',
            'workingCopiesById',
            'processUIStateById',
            'processErrorsById',
            'revisionHistoriesById',
            'processRevisionsById',
            'processRevisionErrorsById',
            'runParametersById',
            'dataConsolidatorRunsById',
            'dependencyTreeById',
            'projectParametersById'
        ];
    }

    getStoreKey() {
        return 'processes';
    }

    getReducer() {
        return (state = this.getInitialState(), action) => {
            let newState = state;

            switch (action.type) {

                case this.PROCESSES_FETCH_SUCCESS: {
                    newState = this._processesFetchSuccess(action, state);
                    break;
                }
                case this.PROCESS_VALIDATE_SUCCESS: {
                    newState = this._processValidateSuccess(action, state);
                    break;
                }
                case this.PROCESS_FETCH_SUCCESS: {
                    newState = this._processFetchSuccess(action, state);
                    break;
                }
                case this.PROCESS_ORIGINAL_FETCH_SUCCESS: {
                    newState = this._processOriginalFetchSuccess(action, state);
                    break;
                }
                case this.PROCESS_REVISION_FETCH_SUCCESS: {
                    newState = this._processRevisionFetchSuccess(action, state);
                    break;
                }
                case this.PROCESS_NEW_SUCCESS: {
                    newState = this._processNewSuccess(action, state);
                    break;
                }
                case this.PROCESS_SAVE_SUCCESS: {
                    newState = this._processSaveSuccess(action, state);
                    break;
                }
                case this.PROCESS_SAVE_VALIDATION_SUCCESS: {
                    newState = this._processSaveValidationSuccess(action, state);
                    break;
                }
                case this.PROCESS_DELETE_SUCCESS: {
                    newState = this._processDeleteSuccess(action, state);
                    break;
                }
                case this.PROCESS_UPDATE_SUCCESS: {
                    newState = this._updateProcessSuccess(action, state);
                    break;
                }
                case this.PROCESS_RUN_PARAMETERS_UPDATE: {
                    newState = this._processRunParametersUpdate(action, state);
                    break;
                }
                case this.PROCESS_UNCACHE: { // wipe a temporary process from the cache
                    newState = this._processUncache(action, state);
                    break;
                }
                case TabsService.TAB_CLOSE: { // when tab closes, we have to wipe the cache
                    newState = this._tabClose(action, state);
                    break;
                }
                case this.PROCESS_OWNERS_FETCH_SUCCESS: {
                    newState = this._processOwnersFetchSuccess(action, state);
                    break;
                }
                case this.PROCESS_OWNERS_SAVE_SUCCESS: {
                    newState = this._processOwnersSaveSuccess(action, state);
                    break;
                }
                case this.PROCESS_REVISIONS_FETCH_SUCCESS:
                    newState = Object.assign({}, state);
                    newState.revisionHistoriesById[action.processId] = action.response;
                    break;
                case this.PROCESS_DEPENDENCIES_FETCH_SUCCESS:
                    newState = Object.assign({}, state);
                    newState.dependencyTreeById[action.id] = action.response;
                    break;
                case this.PROCESS_GET_RUNS_SUCCESS:
                    newState = this._processGetRunsSuccess(action, state);
                    break;
                case this.PROCESS_GET_RUNS_ERROR:
                    newState = this._processGetRunsError(action, state);
                    break;
                case this.PROCESS_DELETE_RUN_SUCCESS:
                    newState = this._processDeleteRunSuccess(action, state);
                    break;
                case DataExplorerService.DATASTREAMS_POLL_SUCCESS:
                    newState = this._datastreamsPollSuccess(action, state);
                    break;
                case this.PROCESS_UPDATE_UI_STATE:
                    newState = this._updateProcessUIState(action, state);
                    break;
                case this.PROCESS_CREATE_PROJECT_UPDATE:
                    newState = this._processCreateProjectParametersUpdate(action, state);
                    break;

                default:  // stupid linting rule requires a default case
                    break;
            }
            return newState;
        };
    }

    saveProcess(processId, revisionNum) {
        const action = this._getSaveProcessAction(processId, revisionNum);
        this.dispatch(action);
    }

    deleteProcess(processId) {
        this.deleteProcesses([processId]);
    }

    deleteProcesses(processIds) {
        this.dispatch({
            type: this.PROCESS_DELETE_START,
            processIds
        });
    }

    /**
     * Use this to update a process in the store.  Components should call this method after they have made
     * a deep copy of their current process prop and set all correlated values accordingly.
     * @param processId - the original id of the process (in case it was renamed)
     * @param process - MUST be a deep copy of the current process in the store!
     * @param processUI - use if the change needs to modify the UI state as well
     */
    updateProcess(processId, process, processUI, callbacks) {

        if (!processUI) {
            processUI = this.getMyState().processUIStateById[process.name];
        }

        this.dispatch({
            type: this.PROCESS_UPDATE_WITH_CALLBACKS,
            processId,
            process,
            processUI,
            callbacks
        });
    }

    updateRunParameters(processId, parameters) {
        this.dispatch({
            type: this.PROCESS_RUN_PARAMETERS_UPDATE,
            processId,
            parameters
        });
    }

    /**
     * @param processId
     * @param string[] owners - array of usernames
     */
    saveProcessOwners(processId, owners) {
        this.dispatch({
            type: this.PROCESS_OWNERS_SAVE_START,
            processId,
            owners
        });
    }

    saveAsNewProcess(process, revisionNum, newName) {
        const newProcess = _.cloneDeep(process);
        newProcess.name = newName;
        const processId = newName;

        let saveAsPreviousProcessId = process.name;
        if (revisionNum) {
            saveAsPreviousProcessId = TabsService.getRevisionTabText(process.name, revisionNum);
        }
        this.dispatch({
            type: this.PROCESS_SAVE_START,
            processId,
            process: newProcess,
            saveAsPreviousProcessId,
            revisionNum
        });
    }

    /**
     * Saves the process if needed and then synchronously runs the process after save complete.
     * @param {string} processId
     */
    saveAndRunProcess(processId) {
        const state = this.getMyState(this.getStore().getState());
        const action = Object.assign({},
            this._getSaveProcessAction(processId),
            this._getRunProcessAction(processId)
        );
        let isDirty = state.processUIStateById[processId].dirty;
        const parameters = _.cloneDeep(state.runParametersById[processId].parameters);

        // We are storing the data_locations separately from the rest of the run parameters because they are used
        // by the data explorer as well.
        _.set(action.process, 'ui_state.data_locations', parameters.data_locations);
        delete parameters.data_locations;

        // Backwards compatibility - clean up values at old location
        delete action.process.ui_state.start_date;
        delete action.process.ui_state.end_date;
        delete action.process.ui_state.run_locations;
        delete action.process.ui_state.time_range;

        _.set(action.process, 'ui_state.run_parameters', parameters);

        action.isDirty = true;
        this.dispatch(action);
    }

    saveIgnoreValidation(processId) {
        const state = this.getMyState(this.getStore().getState());
        const originalProcess = _.cloneDeep(state.originalCopiesById[processId]);

        // new process doesn't need to save validation until new process as a whole is saved
        if (originalProcess) {
            const workingProcess = _.cloneDeep(state.workingCopiesById[processId]);
            const ignoreValidation = workingProcess.ui_state.ignore_validation;

            _.set(originalProcess, 'ui_state.ignore_validation', ignoreValidation);

            this.dispatch({
                type: this.PROCESS_SAVE_VALIDATION_START,
                processId,
                originalProcess,
                workingProcess
            });
        }
    }

    fetchProcessOwnersIfNeeded(processId) {
        const myState = this.getMyState(this.getStore().getState());
        if (!myState.processOwnersById[processId]) {
            this.dispatch({
                type: this.PROCESS_OWNERS_FETCH_START,
                processId
            });
        }
    }

    fetchDependencyTreeIfNeeded(id) {
        const myState = this.getMyState(this.getStore().getState());
        if (!myState.dependencyTreeById[id]) {
            this.dispatch({
                type: this.PROCESS_DEPENDENCIES_FETCH_START,
                id
            });
        }
    }

    fetchProcessesIfNeeded() {
        const myState = this.getMyState(this.getStore().getState());
        const processes = myState.processesById;

        if (Object.keys(processes).length === 0) {
            this.dispatch({
                type: this.PROCESSES_FETCH_START
            });
        }
    }

    fetchProcessIfNeeded(processId, processUI) {
        //TODO: SM for moment I'm just going to say if we don't pass in wizard it's going to default to 'standard'
        // until we work out how we want to save preferences in local storage
        if (!processUI || !processUI.mode) {
            processUI = { mode: 'standard' };
        }

        const myState = this.getMyState(this.getStore().getState());

        if (!myState.workingCopiesById[processId]) {
            this.dispatch({
                type: this.PROCESS_FETCH_START,
                processId,
                processUI
            });
        }
    }

    fetchOriginalProcessIfNeeded(processId) {
        // only need the original process for depencencies view
        // don't need all the validation and explored data
        const myState = this.getMyState(this.getStore().getState());

        if (!myState.originalCopiesById[processId]) {
            this.dispatch({
                type: this.PROCESS_ORIGINAL_FETCH_START,
                processId
            });
        }
    }

    fetchProcessRevisionIfNeeded(processId, revisionNum) {
        //TODO: SM for moment I'm just going to say if we don't pass in wizard it's going to default to 'standard'
        // until we work out how we want to save preferences in local storage
        const processUI = { mode: 'standard' };

        const myState = this.getMyState(this.getStore().getState());
        //if process has been renamed and hasn't bee saved need to get original processId
        let originalId = processId;
        if (myState.originalCopiesById[processId]) {
            originalId = myState.originalCopiesById[processId].name;
        }
        if (!myState.processRevisionsById[processId]) {
            this.dispatch({
                type: this.PROCESS_REVISION_FETCH_START,
                processId,
                originalId,
                revisionNum
            });
        } else {
            if (!myState.processRevisionsById[processId][revisionNum]) {
                this.dispatch({
                    type: this.PROCESS_REVISION_FETCH_START,
                    processId,
                    originalId,
                    revisionNum,
                    processUI
                });
            }
        }
    }

    fetchProcessRevisionsIfNeeded(processId) {
        const myState = this.getMyState(this.getStore().getState());

        //if process has been renamed and hasn't bee saved need to get original processId
        let originalId = processId;
        if (myState.originalCopiesById[processId]) {
            originalId = myState.originalCopiesById[processId].name;
        }
        if (!myState.revisionHistoriesById[processId]) {
            this.dispatch({
                type: this.PROCESS_REVISIONS_FETCH_START,
                processId,
                originalId
            });
        }
    }

    /**
     * Wipe the process from the cache
     * @param processId
     */
    discardProcess(processId) {
        this.dispatch({
            type: this.PROCESS_UNCACHE,
            processId
        });
    }

    newProcess(processId, process, openProcessInNewTab) {
        let newProcess = process;
        if (!newProcess) {
            newProcess =  _.cloneDeep(Constants.PROCESS_NEW); // standard defaults
        }
        newProcess.name = processId;

        this.dispatch({
            type: this.PROCESS_NEW,
            process,
            processId,
            openProcessInNewTab
        });
    }

    updateCreateProjectParameters(processId, parameters) {
        this.dispatch({
            type: this.PROCESS_CREATE_PROJECT_UPDATE,
            processId,
            parameters
        });
    }

    runCreateAdiProject(processId) {
        const state = this.getMyState(this.getStore().getState());
        const parameters = state.projectParametersById[processId].parameters;
        
        this.dispatch({
            type: this.PROCESS_CREATE_PROJECT_START,
            processId,
            parameters
        });
    }

    fetchDataConsolidatorRunsIfNeeded(processId, force) {

        const myState = this.getMyState(this.getStore().getState());

        if (!myState.dataConsolidatorRunsById[processId] || force) {
            this.dispatch({
                type: this.PROCESS_GET_RUNS_START,
                processId
            });
        }
    }

    deleteDataConsolidatorRun(processId, runDate) {
        this.dispatch({
            type: this.PROCESS_DELETE_RUN_START,
            processId,
            runDate
        });
    }

    importDataConsolidatorRunOutput(processId, runDate, dod) {
        this.dispatch({
            type: this.PROCESS_IMPORT_RUN_OUPUT_START,
            processId,
            runDate,
            dod
        });
    }

    cancelDataConsolidatorRun(processId, runDate) {
        this.dispatch({
            type: this.PROCESS_CANCEL_RUN_START,
            processId,
            runDate
        });
    }

    updateProcessUIState(processId, uiState) {
        this.dispatch({
            type: this.PROCESS_UPDATE_UI_STATE,
            processId,
            uiState
        });
    }

    _copyProcessState(state) {
        const newState = Object.assign({}, state, {
            workingCopiesById: Object.assign({}, state.workingCopiesById),
            originalCopiesById: Object.assign({}, state.originalCopiesById),
            processUIStateById: Object.assign({}, state.processUIStateById),
            processErrorsById: Object.assign({}, state.processErrorsById),
            runParametersById: Object.assign({}, state.runParametersById),
            projectParametersById: Object.assign({}, state.projectParametersById)
        });
        return newState;
    }

    _getSaveProcessAction(processId, revisionNum) {
        let saveProcessId = processId;
        let process = {};
        let saveAsPreviousProcessId = null;
        if (revisionNum) {
            process = this.getMyState(this.getStore().getState()).processRevisionsById[processId][revisionNum];

            //saving revision needs to rename tab same as "save as" action
            saveAsPreviousProcessId = TabsService.getRevisionTabText(processId, revisionNum);
        } else {
            // If the process has been renamed, we need to send the old process id, but send the new name
            // in the json so the perl scripts will rename correctly
            process = this.getMyState(this.getStore().getState()).workingCopiesById[processId];
            if (process.oldName) {
                saveProcessId = process.oldName;
            }
        }

        return {
            type: this.PROCESS_SAVE_START,
            processId: saveProcessId,
            process,
            saveAsPreviousProcessId
        };
    }

    _getRunProcessAction(processId) {
        const myState = this.getMyState(this.getStore().getState());
        const parameters = myState.runParametersById[processId].parameters;
        return {
            type: this.PROCESS_RUN_START,
            processId,
            parameters
        };
    }

    _uncacheProcess(state, processId) {
        // remove all the substates associated with this process
        this.getSubstateKeys().forEach(key => {
            delete state[key][processId];
        });
    }

    _processesFetchSuccess(action, state) {
        const newState = Object.assign({}, state);
        const sortedIds = this._getSortIds(Object.keys(action.response));
        newState.processesById = action.response;
        newState.sortedIds = sortedIds;
        return newState;
    }

    _getSortIds($arr) {

        // perform a natural sort, so that numbers embedded in strings are sorted in correct order
        // (i.e., proc1, proc2, ..., proc10, etc.)
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        return $arr.sort(collator.compare);
    }

    _processFetchSuccess(action, state) {
        const newState = this._copyProcessState(state);
        const processData = action.response;
        const processUI = Object.assign({ showWizardInputQC: false, showWizardOutputQC: false }, action.processUI);

        newState.workingCopiesById[action.processId] = processData;
        newState.originalCopiesById[action.processId] = $.extend(true, {}, processData);
        newState.processUIStateById[action.processId] = processUI;
        newState.runParametersById[action.processId] = {};
        // TODO: add data explorer state too

        return newState;
    }

    _processOriginalFetchSuccess(action, state) {
        const newState = this._copyProcessState(state);
        const processData = action.response;

        newState.originalCopiesById[action.processId] = $.extend(true, {}, processData);
        return newState;
    }

    _processRevisionFetchSuccess(action, state) {
        const newState = Object.assign({}, state, { processRevisionsById: Object.assign({}, state.processRevisionsById) });
        const processData = action.response;
        //this._fillMissingTransformParameters(processData);

        if (!newState.processRevisionsById[action.processId]) {
            newState.processRevisionsById = Object.assign({}, { [action.processId]: {} });
        }
        newState.processRevisionsById[action.processId] = Object.assign({}, newState.processRevisionsById[action.processId],
            { [action.revisionNum]: processData });

        return newState;
    }

    _processNewSuccess(action, state) {
        const newState = this._copyProcessState(state);
        newState.workingCopiesById[action.processId] = action.process;
        newState.processUIStateById[action.processId] = { dirty: true }; // new processes are dirty until saved
        newState.runParametersById[action.processId] = {};
        return newState;
    }

    _processSaveSuccess(action, state) {
        const newState = this._copyProcessState(state);
        const process = action.response;
        const newId = action.processId;
        let oldId = null;

        if (process.oldName) { // this is a rename
            oldId = process.oldName;
            delete process.oldName;

            newState.processOwnersById[newId] = newState.processOwnersById[oldId];
            delete newState.processOwnersById[oldId];

            newState.processUIStateById[newId] = newState.processUIStateById[oldId];
            delete newState.processUIStateById[oldId];
        }
        newState.workingCopiesById[newId] = process;
        newState.originalCopiesById[newId] = $.extend(true, {}, process);

        // force revision history list and dependencies to update on save
        delete newState.revisionHistoriesById[newId];
        delete newState.dependencyTreeById[newId];

        // Make sure the process is in processesById and sortedIds lists
        // It might not be in there if the process was new or if the process was renamed!
        // We only need to add this if the processes list has already been loaded
        if (!(newId in state.processesById) && !_.isEmpty(state.processesById)) {
            newState.processesById = Object.assign({}, state.processesById);
            newState.sortedIds = [...state.sortedIds];
            newState.sortedIds.push(newId);

            // If the process was renamed, then we need to remove it from processes by id.
            // We have to make sure the oldId is actually in the state, because if a rename
            // happened in the new process wizard, there will be an oldId, but no stored state
            // for that ID because the wizard isn't persisted until it is saved.
            if (oldId && newState.processesById[oldId]) { // this is a rename
                const processCatalogState = Object.assign({}, newState.processesById[oldId]);
                processCatalogState.id = newId;
                newState.processesById[newId] = processCatalogState;
                delete newState.processesById[oldId];

                _.remove(newState.sortedIds, id => {
                    return id === oldId;
                });

                // also need to rename if the process is in the processOwnersById substate map
                this._transferSubstate(newState, oldId, newId, 'processOwnersById');

            } else { // this is new
                newState.processesById[newId] = {
                    id: newId,
                    type: action.response.type,
                    prod: false
                };
            }

            newState.sortedIds = this._getSortIds(newState.sortedIds);

        }

        // Reset dirty to false, as we have just saved
        if (!newState.processUIStateById[newId]) {
            // If it's a new process, then the ui state may not exist yet
            newState.processUIStateById[newId] = {};
        }
        newState.processUIStateById[newId].dirty = false;

        return newState;
    }

    _processSaveValidationSuccess(action, state) {
        const newState = this._copyProcessState(state);
        const process = action.process;
        const workingProcess = action.workingProcess;
        const processId = workingProcess.name;

        newState.originalCopiesById[processId] = $.extend(true, {}, process);
        newState.processUIStateById[processId].dirty = this._isDirty(workingProcess, process);

        return newState;
    }

    _isDirty(process, processOriginalCopy) {
        let dirty = false;
        if (processOriginalCopy) {
            const workingCopyToDiff = JSON.parse(JSON.stringify(process));
            const originalCopyToDiff = JSON.parse(JSON.stringify(processOriginalCopy));

            if (!_.isEqual(workingCopyToDiff, originalCopyToDiff)) {
                dirty = true;
            }
        } else {
            dirty = true;
        }
        return dirty;
    }

    _transferSubstate(state, oldProcessName, newProcessName, key) {
        // Only transfer the state if it currently exists for that process
        if (oldProcessName in state[key]) {
            const propertyValue = state[key][oldProcessName];
            delete state[key][oldProcessName];
            state[key][newProcessName] = propertyValue;
        }
    }

    /**
     * Handle a process change action.
     * @param newState
     * @param action
     * @returns {*}
     * @private
     */
    _updateProcessSuccess(action, state) {
        const newState = this._copyProcessState(state);

        const processId = action.processId;
        const processName = action.process.name;

        // See if the process was renamed, which requires special behavior
        if (processId !== processName) {
            const oldName = processId;
            const newName = processName;

            // If we have renamed the process, we need to transfer the state to the new id
            this.getSubstateKeys().forEach(key => {
                this._transferSubstate(newState, oldName, newName, key);
            });

            // Make sure the working copy and the process UI are set to the values passed via the action
            newState.workingCopiesById[newName] = action.process;
            if (action.processUI) {
                newState.processUIStateById[newName] = action.processUI;
            }

        } else {
            newState.workingCopiesById[processName] = action.process;

            if (action.processUI) { // Update the process UI if passed
                newState.processUIStateById[processName] = action.processUI;
            }
        }

        // see if we need to display a dirty indicator (if working copy state is different than original)
        let processOriginalCopy = newState.originalCopiesById[processName];
        newState.processUIStateById[processName].dirty = this._isDirty(action.process, processOriginalCopy);

        return newState;
    }

    _processDeleteSuccess(action, state) {
        const newState = this._copyProcessState(state);

        const sortedIds = [...state.sortedIds];
        action.processIds.forEach((processId) => {

            // remove all the substates associated with this process
            this.getSubstateKeys().forEach(key => {
                delete newState[key][processId];
            });

            // remove the process from the catalog
            delete newState.processesById[processId];
            delete newState.processOwnersById[processId];
            const index = sortedIds.indexOf(processId);
            sortedIds.splice(index, 1);
        });
        newState.sortedIds = sortedIds;
        return newState;
    }

    _processValidateSuccess(action, state) {
        let newState = null;

        if (action.revisionNum) { // we are validating a revision
            newState = Object.assign({}, state, { processRevisionErrorsById: Object.assign({}, state.processRevisionErrorsById) });

            if (!newState.processRevisionErrorsById[action.processId]) {
                newState.processRevisionErrorsById[action.processId] = {};
            }
            newState.processRevisionErrorsById[action.processId][action.revisionNum] = action.validationResults;

        } else { // we are validating a regular process
            newState = Object.assign({}, state, { processErrorsById: Object.assign({}, state.processErrorsById) });
            newState.processErrorsById[action.processId] = action.validationResults;
        }

        return newState;
    }

    _processRunParametersUpdate(action, state) {
        const newState = this._copyProcessState(state);
        const processId = action.processId;
        const parameters = action.parameters;
        const errors = new ProcessValidator(newState.workingCopiesById[processId]).validateRunParameters(parameters);
        newState.runParametersById[action.processId] = {
            parameters,
            errors
        };
        return newState;
    }

    _processCreateProjectParametersUpdate(action, state) {
        const newState = this._copyProcessState(state);
        const processId = action.processId;
        const parameters = action.parameters;
        
        newState.projectParametersById[processId] = {
            parameters
        };
        return newState;
    }

    _tabClose(action, state) {
        const newState = this._copyProcessState(state);

        action.tabIds.forEach((tab) => {
            const tabObj = TabsService.getObjFromTabText(tab);
            const processId = tabObj.processId;
            const revisionNum = tabObj.revisionNum;

            // if process revision by id doesn't exist, means process was renamed and doesn't need to be deleted
            if (revisionNum && newState.processRevisionsById[processId]) {
                delete newState.processRevisionsById[processId][revisionNum];

                //TODO: fix process revision validation -- not part of current flow
                if (newState.processRevisionErrorsById[processId]) {
                    if (newState.processRevisionErrorsById[processId][revisionNum]) {
                        delete newState.processRevisionErrorsById[processId][revisionNum];
                    }

                    if (Object.keys(newState.processRevisionErrorsById[processId]).length === 0) {
                        delete newState.processRevisionErrorsById[processId];
                    }
                }
                if (Object.keys(newState.processRevisionsById[processId]).length === 0) {
                    delete newState.processRevisionsById[processId];
                }
            } else {
                this._uncacheProcess(newState, processId);
            }
        });
        return newState;
    }

    _processUncache(action, state) {
        const newState = this._copyProcessState(state);
        this._uncacheProcess(newState, action.processId);
        return newState;
    }

    _processOwnersFetchSuccess(action, state) {
        const newState = Object.assign({}, state, { processOwnersById: Object.assign({}, state.processOwnersById) });
        const owners = action.response;
        newState.processOwnersById[action.processId] = owners;
        return newState;
    }

    _processOwnersSaveSuccess(action, state) {
        const newState = Object.assign({}, state, {
            processOwnersById: Object.assign({}, state.processOwnersById)
        });
        const owners = action.response;
        newState.processOwnersById[action.processId] = owners;
        return newState;
    }

    _processGetRunsSuccess(action, state) {
        const newState = Object.assign({}, state, { dataConsolidatorRunsById: Object.assign({}, state.dataConsolidatorRunsById) });
        const runList = action.response;
        newState.dataConsolidatorRunsById[action.processId] = runList;

        return newState;
    }

    _processDeleteRunSuccess(action, state) {
        const newState = Object.assign({}, state, { dataConsolidatorRunsById: Object.assign({}, state.dataConsolidatorRunsById) });
        let runsList = [...state.dataConsolidatorRunsById[action.processId]]; // make a copy of the current list

        // Remove the deleted entity
        runsList =  runsList.filter(value => {
            return value.runDate !== action.runDate;
        });

        newState.dataConsolidatorRunsById[action.processId] = runsList;
        return newState;
    }

    _processGetRunsError(action, state) {
        // Mark as an error
        const newState = Object.assign({}, state, { dataConsolidatorRunsById: Object.assign({}, state.dataConsolidatorRunsById) });
        newState.dataConsolidatorRunsById[action.processId] = 'Error';

        return newState;
    }

    _datastreamsPollSuccess(action, state) {
        // If the process gets closed before the data explorer finishes, there's a chance that the process no longer
        // exists in the state, if this is the case, then we do nothing
        const process = state.workingCopiesById[action.processId];

        if (process) {
            const datastreamsResponse = action.datastreams;
            const datastreamNames = Object.keys(datastreamsResponse);
            const exploredData = {};

            for (let i = 0; i < datastreamNames.length; i++) {
                const datastreamName = datastreamNames[i];
                exploredData[datastreamName] = { currentData: datastreamsResponse[datastreamName] };
            }

            const updatedProcess = ProcessUtils.fixProcessModel(process, state.processUIStateById[process.name], exploredData);
            action.process = updatedProcess;
            action.validationResults = new ProcessValidator(updatedProcess).validateProcess();

            let newState = this._updateProcessSuccess(action, state); // update transform parameters in the store
            newState = this._processValidateSuccess(action, newState); // revalidate the process

            // Check to see if the process state actually changed.  If it didn't then don't return the new, deep copied
            // object, since that will cause all the components to redraw!
            const newProcess = newState.workingCopiesById[action.processId];
            if (this._isDirty(process, newProcess)) {
                // Log what changed to the console so it's easier to debug
                console.log('Process changed based upon data explorer results!');
                console.log('Process BEFORE data explorer:');
                console.log(JSON.stringify(process, null, 2));
                console.log('Process AFTER data explorer:');
                console.log(JSON.stringify(newProcess, null, 2));
                return newState;

            } else {
                return state;
            }

        } else {
            return state;
        }
    }

    _updateProcessUIState(action, state) {
        const newState = this._copyProcessState(state);
        const processId = action.processId;
        const uiState = action.uiState;

        if (newState.processUIStateById[processId]) {
            newState.processUIStateById[processId] = Object.assign({}, newState.processUIStateById[processId], uiState);
        }
        return newState;
    }

}

export default new ProcessService();



// WEBPACK FOOTER //
// ./src/services/ProcessService.js